export default {
  en: {
    title: "",
  },
  pl: {
    title: "",
    button: "Weź udział",
    urlButton: "https://app.evenea.pl/event/hack4change2027/",
    menu: [
      {
        name: "Idea",
        link: "/#beTheChange",
      },
      {
        name: "Obszary tematyczne",
        link: "/#obszary-tematyczne",
      },
      {
        name: "Dla kogo?",
        link: "/#forWho",
      },
      {
        name: "Lokalizacja",
        link: "/#lokalizacja",
      },
      // {
      //   name: "Propozycje zadań",
      //   link: "/#propozycje",
      // },
      // {
      //   name: "Warsztaty",
      //   link: "/workshops",
      // },
      {
        name: "Mentorzy",
        link: "/#mentorzy",
      },
      {
        name: "Korzyści",
        link: "/#korzysci",
      },
      {
        name: "Harmonogram",
        link: "/#harmonogram",
      },
      {
        name: "FAQ",
        link: "/#faq",
      },

      {
        name: "Edycje ubiegłe",
        subMenu: [
          {
            name: "2026",
            link: "/summary-2026",
          },
          {
            name: "2025",
            link: "/summary-2025",
          },
          {
            name: "2024",
            link: "/summary-2024",
          },
          {
            name: "2023",
            link: "/summary-2023",
          },
          {
            name: "2022",
            link: "/summary-2022",
          },
          {
            name: "2020",
            link: "/summary-2020",
          },
        ],
      },
      {
        name: "Współpraca",
        link: "/#idea",
      },
    ],
  },
}
